var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#EFF5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_10027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8917 22.375C18.0243 22.4572 18.1773 22.5005 18.3333 22.5C18.4638 22.4992 18.5922 22.4678 18.7083 22.4083L25.375 19.075C25.5115 19.0051 25.6261 18.8988 25.706 18.768C25.786 18.6371 25.8284 18.4867 25.8284 18.3333C25.8284 18.18 25.786 18.0296 25.706 17.8987C25.6261 17.7678 25.5115 17.6616 25.375 17.5917L18.7083 14.2583C18.5815 14.1944 18.4404 14.164 18.2985 14.1699C18.1565 14.1759 18.0185 14.218 17.8974 14.2923C17.7763 14.3666 17.6763 14.4706 17.6067 14.5945C17.5372 14.7184 17.5004 14.8579 17.5 15V21.6667C17.4997 21.8083 17.5355 21.9476 17.6041 22.0716C17.6726 22.1955 17.7716 22.2999 17.8917 22.375ZM19.1667 16.35L23.1333 18.3333L19.1667 20.3167V16.35ZM29.1667 10H14.1667C13.9457 10 13.7337 10.0878 13.5774 10.2441C13.4211 10.4004 13.3333 10.6123 13.3333 10.8333V25.8333C13.3333 26.0543 13.4211 26.2663 13.5774 26.4226C13.7337 26.5789 13.9457 26.6667 14.1667 26.6667H29.1667C29.3877 26.6667 29.5996 26.5789 29.7559 26.4226C29.9122 26.2663 30 26.0543 30 25.8333V10.8333C30 10.6123 29.9122 10.4004 29.7559 10.2441C29.5996 10.0878 29.3877 10 29.1667 10ZM28.3333 25H15V11.6667H28.3333V25ZM26.6667 29.1667C26.6667 29.3877 26.5789 29.5996 26.4226 29.7559C26.2663 29.9122 26.0543 30 25.8333 30H10.8333C10.6123 30 10.4004 29.9122 10.2441 29.7559C10.0878 29.5996 10 29.3877 10 29.1667V14.1667C10 13.9457 10.0878 13.7337 10.2441 13.5774C10.4004 13.4211 10.6123 13.3333 10.8333 13.3333C11.0543 13.3333 11.2663 13.4211 11.4226 13.5774C11.5789 13.7337 11.6667 13.9457 11.6667 14.1667V28.3333H25.8333C26.0543 28.3333 26.2663 28.4211 26.4226 28.5774C26.5789 28.7337 26.6667 28.9457 26.6667 29.1667Z",
    fill: "#99A4A3"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E9F1F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_10027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanName);
export default __webpack_public_path__ + "static/media/planName.c5047e41d19e90f4eebaa53a924be9d1.svg";
export { ForwardRef as ReactComponent };